export default "__VITE_ASSET__d719afa2__"